import React from 'react';
import * as THREE from 'three';

interface TongsProps {
  position?: [number, number, number];
  rotation?: [number, number, number];
  scale?: number;
  /** 0 = closed (gripping), 1 = fully open. */
  openAmount?: number;
}

/**
 * Crucible tongs — long stainless-steel arms with curved tips used to
 * grip and lift a hot crucible lid. The two arms hinge near the top of
 * the handle and flare outward when `openAmount` increases.
 */
export function Tongs({
  position = [0, 0, 0],
  rotation = [0, 0, 0],
  scale = 1,
  openAmount = 0.25,
}: TongsProps) {
  const handleLength = 0.22;
  const armLength = 0.18;
  const armRadius = 0.005;
  const openAngle = THREE.MathUtils.lerp(0.05, 0.28, openAmount);

  const ArmGroup = ({ sign }: { sign: 1 | -1 }) => (
    <group position={[0, -handleLength / 2 + 0.005, 0]} rotation={[0, 0, sign * openAngle]}>
      <mesh position={[0, -armLength / 2, 0]} castShadow>
        <cylinderGeometry args={[armRadius, armRadius * 0.85, armLength, 14]} />
        <meshStandardMaterial color="#b8bcc4" metalness={0.85} roughness={0.3} />
      </mesh>
      {/* Curved tip */}
      <mesh
        position={[sign * 0.018, -armLength + 0.005, 0]}
        rotation={[0, 0, sign * -0.6]}
        castShadow
      >
        <torusGeometry args={[0.012, armRadius * 0.85, 10, 18, Math.PI]} />
        <meshStandardMaterial color="#a9adb5" metalness={0.85} roughness={0.32} />
      </mesh>
    </group>
  );

  return (
    <group position={position} rotation={rotation} scale={scale}>
      <mesh castShadow>
        <cylinderGeometry args={[armRadius * 1.1, armRadius * 1.1, handleLength, 18]} />
        <meshStandardMaterial color="#7f7f87" metalness={0.55} roughness={0.5} />
      </mesh>
      {/* Hinge knob */}
      <mesh position={[0, -handleLength / 2 + 0.005, 0]} castShadow>
        <sphereGeometry args={[armRadius * 1.6, 12, 12]} />
        <meshStandardMaterial color="#4a4a52" metalness={0.7} roughness={0.5} />
      </mesh>
      <ArmGroup sign={1} />
      <ArmGroup sign={-1} />
    </group>
  );
}

export default Tongs;
